import { TextQuestion } from "@cur8/questionnaire";
import { Trans } from "./trans";

export const AdditionalWorries = new TextQuestion(
  <Trans.AdditionalWorries.Question />
);
